const adaptReservationData = (reservationData, callback) => {
    //console.log(reservationData);
    callback(reservationData);
};

const coreAPI = (props, currentUser, setToolbar) => ({
    setToolbarContent: (toolbar) => {
        setToolbar(toolbar);
    },

    setCreateExamRequestFunction: (callback) => {
        (this as any)._reservationCallback = callback;
    },

    createExamRequest: (reservationData) => {
        if ((this as any)._reservationCallback) {
            adaptReservationData(reservationData, (adaptedData) => {
                (this as any)._reservationCallback(adaptedData);
            });
        }
    },
});

export default coreAPI;
